import { apiCall } from './gqlClient';
const GENERATEURLFORTRANSLATIONFILE_QUERY = "\n  mutation generateUrlForTranslationFile($project: String!, $language: String!) {\n    generateUrlForTranslationFile(project: $project, language: $language)\n    {\n      success\n\t\t\tpresignedUrl\n      ...fragments\n    }\n  }";
export const generateUrlForTranslationFileApiCall = async function (_ref) {
  let {
    project,
    language
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: GENERATEURLFORTRANSLATIONFILE_QUERY,
    variables: {
      project,
      language
    },
    fragments
  });
};